module.exports = __webpack_public_path__ + "media/scribe.7fc96137.mp3";